import { dictionaries } from './dictionaries'

class DictionaryService {
    private loadedDictionaries: { [key: string]: Promise<Localication> } = {}

    getDictionary(locale: string): Promise<Localication> {
        if (!this.loadedDictionaries[locale]) {
            // Load the dictionary if not already loaded
            this.loadedDictionaries[locale] = dictionaries[locale]()
        }
        return this.loadedDictionaries[locale]
    }
}

export const dictionaryService = new DictionaryService()
